import React from "react";
import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 sf-fade-up">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-navy-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, tone = "navy", testid }) {
  const tones = {
    navy: "text-navy-900 bg-navy-50", green: "text-emerald-700 bg-emerald-50",
    blue: "text-blue-700 bg-blue-50", amber: "text-amber-700 bg-amber-50", red: "text-rose-700 bg-rose-50",
  };
  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-slate-200 p-5 hover:shadow-md transition-shadow sf-fade-up">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</p>
          <p className="font-display text-3xl font-bold text-navy-900 mt-2">{value ?? 0}</p>
        </div>
        {Icon && <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${tones[tone]}`}><Icon size={20} strokeWidth={2} /></div>}
      </div>
    </div>
  );
}

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-slate-400 gap-3">
      <Loader2 className="animate-spin" size={28} />
      <span className="text-sm">{label}...</span>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border-2 border-dashed border-slate-200 rounded-2xl bg-white/60">
      {Icon && <div className="w-14 h-14 rounded-2xl bg-navy-50 text-navy-800 flex items-center justify-center mb-4"><Icon size={26} /></div>}
      <h3 className="font-display font-semibold text-navy-900">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-sm">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
